import React from "react";
import useFooter from '$UTILS/hooks/useFooter';
import { ApiPort } from '$ACTIONS/API';
import CheckImageFormat from "./CheckImageFormat";

const Footer = () => {
	const footerData = useFooter({
        url: ApiPort.Footer,
    });

	return (
		<>
			{footerData ? <footer className="footer">
				<div className="footer-wrapper">
					<ul className="sponsor">
						{Array.isArray(footerData.sponsorship) && footerData.sponsorship?.map((item, index) => (
							item.desktop_order <= 8 && (
								<li key={index} className="item">
									<a href={item?.desktop_forwarding_url}>
										<p className="sponsor-title">{item?.desktop_text}</p>
										<CheckImageFormat
											avifImage={item?.desktop_image_avif}
											defaultImage={item?.desktop_image_webp || item?.desktop_image}
											style={{width:'105px'}}
											className='sponsor-img'
											alt={item?.desktop_text}
										/>
									</a>
								</li>
							)
						))}
					</ul>
					<hr />
					<ul className="sponsor">
						{Array.isArray(footerData.sponsorship) && footerData.sponsorship?.map((item, index) => (
							item.desktop_order > 8 && 17 > item.desktop_order && (
								<li key={index} className="item">
									<a href={item?.desktop_forwarding_url}>
										<p className="sponsor-title">{item?.desktop_text}</p>
										<CheckImageFormat
											avifImage={item?.desktop_image_avif}
											defaultImage={item?.desktop_image_webp || item?.desktop_image}
											style={{width:'105px'}}
											className='sponsor-img'
											alt={item?.desktop_text}
										/>
									</a>
								</li>
							)
						))}
					</ul>
					<hr />

					<div className="game-partner">
						<p className="partner-title">游戏平台</p>
						<div className="group">
							{Array.isArray(footerData.gaming_platform) && footerData.gaming_platform?.map((item, index) => (
								<div key={index} className="img">
									<CheckImageFormat
										avifImage={item?.desktop_image_avif}
										defaultImage={item?.desktop_image_webp || item?.desktop_image}
										style={{width:'105px'}}
										className='partner-img'
										alt={item?.desktop_text}
									/>
								</div>
							))}
        				</div>
					</div>
					<hr />

					<div className="partner">
						<div className="item">
							<p className="partner-title">信息安全</p>
							<div>
								{Array.isArray(footerData.info_security) && footerData.info_security?.map((item, index) => (
									<CheckImageFormat
										key={index}
										avifImage={item?.desktop_image_avif}
										defaultImage={item?.desktop_image_webp || item?.desktop_image}
										style={{height:'50px'}}
										className='partner-img'
										alt={item?.desktop_text}
									/>
								))}
							</div>
						</div>
						<div className="item">
							<p className="partner-title">博彩责任</p>
							<div>
								{Array.isArray(footerData.regulation) && footerData.regulation?.map((item, index) => (
									<CheckImageFormat
										key={index}
										avifImage={item?.desktop_image_avif}
										defaultImage={item?.desktop_image_webp || item?.desktop_image}
										style={{height:'50px'}}
										className='partner-img'
										alt={item?.desktop_text}
									/>
								))}
							</div>
						</div>
						<div className="item">
							<p className="partner-title">支付平台</p>
							<div>
								{Array.isArray(footerData.payment_options) && footerData.payment_options?.map((item, index) => (
									<CheckImageFormat
										key={index}
										avifImage={item?.desktop_image_avif}
										defaultImage={item?.desktop_image_webp || item?.desktop_image}
										style={{height:'32px'}}
										className='partner-img'
										alt={item?.desktop_text}
									/>
								))}
							</div>
						</div>
						<div className="item">
							<p className="partner-title">支援平台</p>
							<div>
								{Array.isArray(footerData.app_platform) && footerData.app_platform?.map((item, index) => (
									<CheckImageFormat
										key={index}
										avifImage={item?.desktop_image_avif}
										defaultImage={item?.desktop_image_webp || item?.desktop_image}
										style={{height:'32px'}}
										className='partner-img'
										alt={item?.desktop_text}
									/>
								))}
							</div>
						</div>
					</div>
				</div>
			</footer> : null}
		</>
	)
}

export default Footer;
